<template>
  <Dialog
    class="got-log-dialog"
    title="领奖记录"
    @close="isOpen = false"
    :open="isOpen"
    show-close
  >
    <div class="table">
      <div class="th">
        <div class="td col1">领奖记录</div>
        <div class="td col2">领取时间</div>
      </div>
      <div class="data">
        <div class="tr" v-for="log in list" :key="log.id">
          <div class="td col1">
            <div class="prize-name">{{ log.gift_name }}</div>
            <div class="role-info">
              {{ log.server_name && log.server_name ? log.server_name+'-'+log.role_name : log.papp_name }} 
            </div>
          </div>
          <div class="td col2 time">{{ log.get_time }}</div>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script>
import Dialog from "@/components/dialog/index.vue";
export default {
  components: {
    Dialog,
  },
  data() {
    return {
      list: [],
      isOpen: false,
    };
  },
  methods: {
    open({ app_type }) {
      this.isOpen = true;
      this.load(app_type);
    },
    load(app_type) {
      const params = {
        tm: Date.now(),
        con_id: this.$xh.xhParams.con_id,
        version: this.$xh.xhParams.version,
        nonce: this.$xh.nonce(),
        app_type,
      };
      params.sign = this.$RSSign(params, this.$xh.xhParams.key);
      this.$ajax({
        method: "get",
        url: this.$api.v2.getRewardLog,
        params,
      })
        .then((res) => {
          if (res.data.code === 200) {
            this.list = res.data.data;
          } else {
            this.$toast(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.got-log-dialog {
  :deep(.outer) {
    .dialog {
      min-height: 15rem;
      .header {
        height: 2rem;
        margin-bottom: 0.5rem;
        .dialog-close {
          top: -0.1rem;
          width: 0.9rem;
        }
      }
    }
  }
}
.table {
  .td {
    padding: 10px;
    box-sizing: border-box;
    &.col1 {
      flex: 1;
      overflow: hidden;
    }
    &.clo2 {
      flex: 1;
      overflow: hidden;
    }
  }
  .data {
    height: 10rem;
    overflow-y: auto;
  }
  .th {
    display: flex;
    border: 0.1rem solid gray;
    border-radius: 0.3rem;
  }
  .tr {
    display: flex;
    align-items: center;
    height: 4rem;
    width: 100%;
  }
  .prize-name {
    color: #d72b2b;
    font-size: 1rem;
    overflow: hidden;
    text-wrap-mode: nowrap;
    text-overflow: ellipsis;
  }
  .role-info {
    margin-top: 0.2rem;
    font-size: 0.75rem;
    color: black;
    overflow: hidden;
    text-wrap-mode: nowrap;
    text-overflow: ellipsis;
  }
  .time {
    font-size: 0.75rem;
    color: black;
    position: relative;
    overflow: hidden;
    text-wrap-mode: nowrap;
    text-overflow: ellipsis;
    top: 0.7rem;
  }
}
</style>
